import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchSingleClient(ctx, data) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/api/clients/${data.id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchClients(ctx, data) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/clients', { params: data })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addClient(ctx, data) {
      return new Promise((resolve, reject) => {
        axios
          .post('/api/clients', data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateClient(ctx, data) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/api/clients/${data.id}`, data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteClient(ctx, data) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/api/clients/${data.id}`, data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
